import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { X } from "lucide-react";

const AddUserModal = ({ show, handleClose, handleSave, mode = "add", user = null, maxUsers = 0, currentUsersCount = 0 }) => {
    const [formData, setFormData] = useState({
        id: undefined,
        fullName: "",
        email: "",
        phone: "",
        status: "ACTIVE",
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (mode === "edit" && user) {
            setFormData({
                id: user.id,
                fullName: user.name || "",
                email: user.email || "",
                phone: user.phone || "",
                status: (user.status === "Active") ? "ACTIVE" : "INACTIVE",
            });
        } else if (mode === "add") {
            setFormData({
                id: undefined,
                fullName: "",
                email: "",
                phone: "",
                status: "ACTIVE",
            });
        }
    }, [mode, user, show]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
        setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
    };

    // const setStatus = (status) => {
    //     setFormData({
    //         ...formData,
    //         status,
    //     });
    // };

    const validate = () => {
        const errs = {};
        // check allowed users when adding
        if (mode === 'add' && maxUsers > 0 && currentUsersCount >= maxUsers) {
            errs.general = `Only ${maxUsers} user(s) allowed for the selected plan.`;
            setErrors(errs);
            return false;
        }
        if (!formData.fullName || !formData.fullName.trim()) {
            errs.fullName = "Full Name is required.";
        }

        if (!formData.email || !formData.email.trim()) {
            errs.email = "Email is required.";
        } else if (!/^\S+@\S+\.\S+$/.test(formData.email.trim())) {
            errs.email = "Enter a valid email address.";
        }

        const phone = (formData.phone || "").trim();
        if (phone && phone !== "-" && phone !== "") {
            console.log("Validating phone:", phone);
            const allowed = /^[\d()+\-.\s]+$/;
            if (!allowed.test(phone)) {
                errs.phone = "Phone number contains invalid characters.";
            } else {
                const digits = phone.replace(/\D/g, "");
                if (digits.length < 7 || digits.length > 15) {
                    errs.phone = "Enter a valid phone number (7-15 digits).";
                }
            }
        }

        setErrors(errs);
        return Object.keys(errs).length === 0;
    };

    const submitHandler = () => {
        if (!validate()) return;
        handleSave(formData, mode);
        handleClose();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            size="lg"
            className="add-user-modal"
        >
            <Modal.Body className="p-0">
                {/* Header */}
                <div className="modal-header-custom">
                    <div>
                        <h2>{mode === "edit" ? "Edit Dashboard User" : "Add Dashboard User"}</h2>
                        <p>Grant someone access to your dashboard</p>
                    </div>

                    <button className="close-btn" onClick={handleClose}>
                        <X size={24} />
                    </button>
                </div>

                {/* Form */}
                <div className="form-section">
                    {errors.general && (
                        <div className="mb-4 text-sm text-[#FF7433] font-semibold">{errors.general}</div>
                    )}
                    <Form>
                        <Form.Group className="mb-4">
                            <Form.Label>
                                Full Name <span className="required">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="fullName"
                                placeholder="e.g. Jane Smith"
                                value={formData.fullName}
                                onChange={handleChange}
                                isInvalid={!!errors.fullName}
                                maxlength={30}
                            />
                            <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>
                                Email Address <span className="required">*</span>
                            </Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                placeholder="e.g. janesmith@gmail.com"
                                value={formData.email}
                                onChange={handleChange}
                                disabled={mode === "edit"}
                                isInvalid={!!errors.email}
                                maxlength={30}
                            />
                            <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                                type="text"
                                name="phone"
                                placeholder="XXX-XXX-XXXX"
                                value={formData.phone === "-" ? "" : (formData.phone || "")}
                                onChange={handleChange}
                                // disabled
                                isInvalid={!!errors.phone}
                            />
                            <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
                        </Form.Group>

                        {/* Status */}
                        {/*mode === "edit" ?
                            <Form.Group>
                                <Form.Label>Status</Form.Label>

                                <div className="status-container">
                                    <button
                                        type="button"
                                        className={`status-btn ${formData.status === "ACTIVE" ? "active" : ""
                                            }`}
                                        onClick={() => setStatus("ACTIVE")}
                                    >
                                        ● ACTIVE
                                    </button>

                                    <button
                                        type="button"
                                        className={`status-btn ${formData.status === "INACTIVE" ? "inactive" : ""
                                            }`}
                                        onClick={() => setStatus("INACTIVE")}
                                    >
                                        INACTIVE
                                    </button>
                                </div>
                            </Form.Group>
                        :""*/}
                    </Form>
                </div>

                {/* Footer */}
                <div className="modal-footer-custom">
                    <Button
                        variant="warning"
                        className="cancel-btn"
                        onClick={handleClose}
                    >
                        CANCEL
                    </Button>

                    <Button
                        variant="info"
                        className="save-btn"
                        onClick={submitHandler}
                    >
                        {mode === "edit" ? "SAVE CHANGES" : "ADD USER"}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddUserModal;